/**
 * Grid Settings
 */

export const baseline = 8;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/styles/grid.ts